import {keycloak} from './keycloak';

export const getJWT = (): string | null | undefined => {

    return keycloak.token;
};

interface VerificationMsg {
  isValid: boolean;
  isHR: boolean;
}

export const jwtIsValid = async (): Promise<VerificationMsg> => {
  if (!keycloak.authenticated) {
    return {isValid: false, isHR: false};
  }

  const tokenParsed = keycloak.tokenParsed as Record<string, any>;
  const roles = tokenParsed?.realm_access?.roles || [];
  return {isValid: true, isHR: roles.includes('hr')};

};
